export default __webpack_public_path__ + "static/media/BTC.8b58a465.svg";